const strings = {
  title: 'Editar Cliente',
  document: 'CPF/CNPJ',
  mail: 'E-mail',
  phone: 'Celular',
  status: 'Status',
  premium: 'Cliente PlantUP IA',
  street: 'Rua',
  district: 'Bairro',
  houseNumber: 'Nº',
  cep: 'CEP',
}

export default strings
